import { memo, useMemo } from "react";
import PropTypes from "prop-types";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const COLORS = [
    "#4c6ef5",
    "#20c997",
    "#f59f00",
    "#845ef7",
    "#ff6b6b",
    "#228be6",
    "#2f9e44",
    "#ffa94d",
    "#9775fa",
    "#ff8787",
];

function TopProductsBarChart({ products }) {
    const chartData = useMemo(() => {
        const labels = products.map((item) => item.product || "Produto");
        const dataPoints = products.map((item) => item.count || 0);
        const backgroundColor = dataPoints.map(
            (_, index) => COLORS[index % COLORS.length]
        );

        return {
            labels,
            datasets: [
                {
                    label: "Pedidos",
                    data: dataPoints,
                    backgroundColor,
                    borderRadius: 6,
                    barThickness: 18,
                    maxBarThickness: 22,
                },
            ],
        };
    }, [products]);

    const options = useMemo(
        () => ({
            indexAxis: "y",
            maintainAspectRatio: false,
            responsive: true,
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    callbacks: {
                        label: (context) => {
                            const value = context.parsed?.x ?? context.parsed ?? 0;
                            return `${value} pedido${value === 1 ? "" : "s"}`;
                        },
                    },
                },
            },
            scales: {
                x: {
                    beginAtZero: true,
                    grid: {
                        borderDash: [4, 4],
                        color: "#e9ecef",
                    },
                    ticks: {
                        precision: 0,
                    },
                },
                y: {
                    grid: {
                        display: false,
                    },
                    ticks: {
                        autoSkip: false,
                        maxRotation: 0,
                        minRotation: 0,
                    },
                },
            },
        }),
        []
    );

    return (
        <div style={{ height: Math.max(140, products.length * 34) }}>
            <Bar data={chartData} options={options} />
        </div>
    );
}

TopProductsBarChart.propTypes = {
    products: PropTypes.arrayOf(
        PropTypes.shape({
            product: PropTypes.string,
            count: PropTypes.number,
        })
    ),
};

TopProductsBarChart.defaultProps = {
    products: [],
};

export default memo(TopProductsBarChart);
